'use client'
import React, { useEffect, useState } from 'react'
import type { Header } from '@/payload-types'
import { HeaderNav } from './Nav'
import { cn } from '@/utilities/cn'

interface HeaderClientProps {
  header: Header
  draftMode: boolean
  darkMode: boolean
  children?: React.ReactNode
}

export const HeaderClient: React.FC<HeaderClientProps> = ({
  header,
  draftMode,
  darkMode = false,
  children,
}) => {
  // State to manage shadow visibility
  const [showShadow, setShowShadow] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      // Check if scroll is past 1/4 screen height
      const scrollThreshold = window.innerHeight / 4
      if (window.scrollY > scrollThreshold) {
        setShowShadow(true)
      } else {
        setShowShadow(false)
      }
    }

    // Add scroll event listener
    window.addEventListener('scroll', handleScroll)

    // Cleanup listener on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <div>
      <header
        className={cn(
          'fixed left-0 top-0 w-full z-20 transition-shadow duration-1000',
          showShadow ? 'shadow-lg' : 'shadow-none',
        )}
        data-theme={darkMode ? 'dark' : 'light'}
      >
        {children}
        <HeaderNav header={header} />
      </header>
    </div>
  )
}
